export default __webpack_public_path__ + "static/media/ka.8634f2d9.jpg";